// extracted by mini-css-extract-plugin
module.exports = {"page":"AreaPageModern_page__3RDE5","page__content":"AreaPageModern_page__content__14GKt"};